import React from 'react';
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form';
import { FormControl, FormHelperText, Input, InputProps } from '@mui/material';
import { CirclePicker } from 'react-color';

type Input = {
  type: 'color';
  color: string;
  rule?: RegisterOptions;
  onChange: (color: any) => void;
  colorMaster: Array<string>;
};

type InputPartialProps = Omit<InputProps, keyof Input>;

export type CustomColorPickerProp = Input & InputPartialProps;

const CustomColorPicker: React.FC<Input & InputPartialProps> = ({
  color,
  rule,
  onChange,
  colorMaster,
  ...InputProps
}) => {
  const { control } = useFormContext();

  return (
    <>
      <CirclePicker color={color} onChange={onChange} width="100%" colors={colorMaster} />
      <Controller
        name="color"
        control={control}
        rules={rule}
        render={({ field, fieldState }) => {
          return (
            <FormControl fullWidth error={Boolean(fieldState.error)}>
              <Input {...field} />
              <FormHelperText>{fieldState.error?.message}</FormHelperText>
            </FormControl>
          );
        }}
      />
    </>
  );
};

export default CustomColorPicker;
